import React from 'react'

//COMPONENTS
import DefaultModel from './DefaultModel'
import ModelWithSearchBar from './ModelWithSearchBar'

const AgencyBanner = ({
  name,
  agencyKey,
  logo,
  bannerImage,
  experienceName,
  experienceCategory,
  bannerModel,
  reviews,
  isMock,
  hide,
  settingsExperience = '',
}) => {
  const handleBannerModel = () => {
    switch (bannerModel) {
      case 1:
        return (
          <DefaultModel
            logo={logo}
            agencyKey={agencyKey}
            name={name}
            bannerImage={bannerImage}
            experienceName={experienceName}
            experienceCategory={
              !!settingsExperience?.name
                ? settingsExperience?.name
                : experienceCategory
            }
            reviews={reviews}
            isMock={isMock}
            hide={hide}
          />
        )
      case 2:
        return (
          <ModelWithSearchBar
            logo={logo}
            agencyKey={agencyKey}
            name={name}
            bannerImage={bannerImage}
            experienceName={experienceName}
            experienceCategory={
              !!settingsExperience?.name
                ? settingsExperience?.name
                : experienceCategory
            }
            reviews={reviews}
            isMock={isMock}
            hide={hide}
          />
        )
      default:
        return (
          <DefaultModel
            logo={logo}
            agencyKey={agencyKey}
            name={name}
            bannerImage={bannerImage}
            experienceName={experienceName}
            reviews={reviews}
            isMock={isMock}
            hide={hide}
          />
        )
    }
  }

  return <>{handleBannerModel()}</>
}

export default AgencyBanner
